/* ig-pdp-sticky-atc.js  v6  2026-08-27
   Sticky price + ADD TO CART bar on mobile product pages.

   ALWAYS VISIBLE, from the top of the page (Larry, 27 Aug: "we need the price
   and add to cart on the bottom always, like with clarity"). Checked against
   withclarity.com: their .product-form__add-to-cart-wrapper is position:fixed
   at the bottom at scroll 0 and stays there the whole way down.

   It does NOT reimplement add-to-cart. The bar's button clicks the theme's own
   input.add-to-cart-btn, so variant selection, validation and the cart drawer
   all behave exactly as they already do.

   Price is read from the VISIBLE price node. The theme also renders a hidden
   %COMPARE_PRICE% template node with the same class, so computed visibility is
   checked rather than trusting querySelector order.

   v5: variantSummary() no longer requires the <select> to be visible - option
   chips hide them, but they are still the source of truth.

   v6: made-to-order sizes. Any selected option matching /or above|contact us/
   turns this bar into CONTACT OUR SALES TEAM, which goes to /pages/contact
   instead of clicking a button Shopify has disabled. Without this the bar would
   read SOLD OUT, which is the wrong message - see ig-enquire.js, which puts the
   matching panel inline on the page.

   Mobile only, product template only. Revert notes in the .css. */
(function () {
  'use strict';
  var MQ = '(max-width: 768px)';
  var ENQ = /or above|contact us/i;
  var LINK = '/pages/contact';
  var bar, priceOut, variantOut, btnOut, atc;

  function visible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  function livePrice() {
    var nodes = document.querySelectorAll('.price__box .price-item--sale, .price__box .price-item--regular, .price_availability_blocks .price-item');
    for (var i = 0; i < nodes.length; i++) if (visible(nodes[i])) return nodes[i];
    return null;
  }

  function variantSummary() {
    var out = [];
    var sels = document.querySelectorAll('select[name^="options["]');
    for (var i = 0; i < sels.length; i++) {
      var v = sels[i].value;
      if (v && out.indexOf(v) === -1) out.push(v);
    }
    var checked = document.querySelectorAll('.product-form input[type=radio]:checked');
    for (var j = 0; j < checked.length; j++) {
      if (checked[j].value && out.indexOf(checked[j].value) === -1) out.push(checked[j].value);
    }
    return out.join(' · ');
  }

  function sync() {
    var summary = variantSummary();
    var enq = ENQ.test(summary);

    var p = livePrice();
    if (p && priceOut) priceOut.textContent = p.textContent.replace(/\s+/g, ' ').trim();

    if (variantOut) {
      variantOut.textContent = summary;
      variantOut.style.display = summary ? '' : 'none';
    }

    if (btnOut) {
      if (enq) {
        btnOut.textContent = 'Contact our sales team';
        btnOut.disabled = false;
        btnOut.setAttribute('data-enq', '1');
      } else if (atc) {
        btnOut.textContent = (atc.value || atc.textContent || 'Add to cart').trim();
        btnOut.disabled = !!atc.disabled;
        btnOut.setAttribute('data-enq', '');
      }
    }
  }

  function build() {
    if (!window.matchMedia || !window.matchMedia(MQ).matches) return;
    if (document.querySelector('.ig-sab')) return;
    if (!document.body) return;

    var candidates = document.querySelectorAll('input.add-to-cart-btn, .add-to-cart-btn, button[name="add"], input[name="add"]');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].closest('form[action*="/cart/add"]')) { atc = candidates[i]; break; }
    }
    if (!atc) atc = candidates[0];
    if (!atc) return;

    bar = document.createElement('div');
    bar.className = 'ig-sab is-visible';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');

    var info = document.createElement('div');
    info.className = 'ig-sab__info';
    variantOut = document.createElement('div');
    variantOut.className = 'ig-sab__variant';
    priceOut = document.createElement('div');
    priceOut.className = 'ig-sab__price';
    info.appendChild(variantOut);
    info.appendChild(priceOut);

    btnOut = document.createElement('button');
    btnOut.type = 'button';
    btnOut.className = 'ig-sab__btn';
    btnOut.textContent = 'Add to cart';
    btnOut.addEventListener('click', function (e) {
      e.preventDefault();
      if (btnOut.getAttribute('data-enq') === '1') { window.location.href = LINK; return; }
      if (atc && !atc.disabled) atc.click();
    });

    bar.appendChild(info);
    bar.appendChild(btnOut);
    document.body.appendChild(bar);
    document.body.classList.add('ig-sab-on');

    sync();

    document.addEventListener('change', function () { setTimeout(sync, 60); }, true);
    document.addEventListener('click', function () { setTimeout(sync, 150); }, true);
    [400, 900, 1600].forEach(function (ms) { setTimeout(sync, ms); });

    if (window.MutationObserver) {
      var host = document.querySelector('.main__product-inner') || document.body;
      new MutationObserver(function () { sync(); })
        .observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  window.addEventListener('load', build);
}());
